import { withTranslation } from "react-i18next";
import OrderProfiles from './OrderProfiles';

export default withTranslation()(OrderProfiles);